// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  CourierCargoLeg,
} from "./types";

export default {
  originKey: __t.string(),
  destKey: __t.string(),
  get cargo() {
    return __t.array(CourierCargoLeg);
  },
  rewardSov: __t.i64(),
  collateralSov: __t.i64(),
  durationS: __t.u32(),
};
